<template>
  <el-dialog
    title="校验报告"
    :visible.sync="dcReportVisible"
    width="750px"
    :before-close="handleClose"
  >
    <table width="100%" cellpadding="5" border="0" class="tm_table_form">
      <tbody>
        <tr>
          <th>用户名:</th>
          <td>{{fvReport.username}}</td>
        </tr>
        <tr>
          <th>报告编号:</th>
          <td>{{fvReport.formatguid}}</td>
        </tr>
        <tr>
          <th>文章标题:</th>
          <td>{{fvReport.formattitle}}</td>
        </tr>
        <tr>
          <th>格式差错率:</th>
          <td>{{fvReport.errorpercentage}}/10000</td>
        </tr>
        <tr>
          <th>检测时间:</th>
          <td>{{fvReport.checkdate}}</td>
        </tr>
        <tr>
          <th>报告在线查看地址:</th>
          <td>
            <a id="paperviewurl1" :href="fvReport.onlineReportUrl" target="_blank">点击去查看</a>
            <input
              type="hidden"
              value="${fvReport.onlineReportUrl}"
              id="paperviewurl2"
            />
          </td>
        </tr>
        <tr>
          <th>报告下载地址:</th>
          <td>
            <a id="paperdownurl1" :href="fvReport.dldUrl" target="_blank">点击下载</a>
            <input
              type="hidden"
              value="${fvReport.dldUrl}"
              id="paperdownurl2"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="dcReportVisible = false"
        >关闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dcReportVisible: false,
      fvReport: {},
    };
  },
  methods: {
    open(res) {
      this.fvReport = res;
      this.dcReportVisible = true;
    },
    handleClose() {
      this.dcReportVisible = false;
      this.fvReport = {};
    },
  },
};
</script>

<style></style>
